import React, { useState, useEffect } from 'react';
import { Column } from '@ant-design/charts';

// const colors = ['#fab74a', '#f9747c', '#36b4ff', '#51826d'];

const colors = ['#54A6FF', '#FFB74A'];

const PercentHistogram = (props) => {
  //console.log("he==> " + props.datainGraph.length);

  var data = [
    {
      name: 'Filed',
      value: 0,
    },
    {
      name: 'Inprogress',
      value: 0,
    }
  ];


  var config = {
    //data: props.datainGraph,
    data: props && props.datainGraph && props.datainGraph.length > 0 ? props.datainGraph : data,
    // data: data,
    xField: 'name',
    yField: 'value',
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    minColumnWidth: 140,
    maxColumnWidth: 140,
    seriesField: 'name',
    color: colors,
    legend: {
      // label: {
      //   position: 'top-right',
      // },
      layout: 'horizontal',
      position: 'top-right'
    },
    appendPadding: 30,
    intervalPadding: 80,
    interactions: [{ type: 'element-active' }],
  };

  return <Column {...config} />;

};

export default PercentHistogram;